import { useCallback, useEffect, useState } from 'react';
import {
  STORE_THEME_CHANGE_EVENT,
  applyStoreThemeToDocument,
  readStoreThemeIsDark,
  persistStoreTheme
} from '../utils/storeTheme';

export default function useGlobalTheme() {
  const [isDarkMode, setIsDarkMode] = useState(() => readStoreThemeIsDark());

  useEffect(() => {
    persistStoreTheme(isDarkMode);
  }, [isDarkMode]);

  useEffect(() => {
    const sync = () => {
      const next = readStoreThemeIsDark();
      setIsDarkMode((prev) => (prev === next ? prev : next));
      applyStoreThemeToDocument(next);
    };

    const onStorage = (e) => {
      if (e.key === 'theme' || e.key === null) sync();
    };

    window.addEventListener(STORE_THEME_CHANGE_EVENT, sync);
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener(STORE_THEME_CHANGE_EVENT, sync);
      window.removeEventListener('storage', onStorage);
    };
  }, []);

  const toggleTheme = useCallback(() => {
    setIsDarkMode((prev) => !prev);
  }, []);

  return { isDarkMode, toggleTheme, setIsDarkMode };
}
